<template>
    <div class="container">
        <h1>支付成功！</h1>
        <p style="color: #67c23a;">订单号：{{ orderId }}</p>
        <p style="color: #67c23a;">支付金额：{{ amount }}元</p>
        <p style="color: #67c23a;">下单时间：{{ time }}元</p>
        <button style="margin-bottom: 15px;" class="btn btn_primary" @click="backToPay">返回</button>
    </div>
</template>

<script>
export default {
    name: 'PayResult',
    data() {
        return {
            orderId: '12345678',
            amount: 0.1,//金额
            time: '2024-5-10 15:22:09',//金额
            payResult: '',// 存放支付结果
            baseUrl: 'https://aviatnetworks.com.cn',
        }
    },
    methods: {
        backToPay() {
            this.$router.push('/pay')
        },
    },
    mounted() {
    },
    created() {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "index";
</style>


// WEBPACK FOOTER //
// src/components/payResult.vue